export default [
 
    {
        tipo: 'ambiente',
        imgpath: 'thumbs/showroom.webp',
        name: 'Showroom',
        type: 'gltfModel',
        path: 'models/showroom.glb'
    },
    {
        tipo: 'ambiente',
        imgpath: 'thumbs/toscana.webp',
        name: 'Toscana',
        type: 'gltfModel',
        path: 'models/toscana.glb'
    },
    {
        tipo: 'ambiente',
        imgpath: 'thumbs/marina.webp',
        name: 'Marina',
        type: 'gltfModel',
        path: 'models/sulmare.glb'
    },
    {
        tipo: 'ambiente',
        imgpath: 'thumbs/newyork.webp',
        name: 'NewYork',
        type: 'gltfModel',
        path: 'models/stanza-ny.glb'
    }

    // {
    //     name: 'envMap',
    //     type: 'cubeTexture',
    //     path:
    //     [
    //         'textures/environmentMaps/1/px.jpg',
    //         'textures/environmentMaps/1/nx.jpg',
    //         'textures/environmentMaps/1/py.jpg',
    //         'textures/environmentMaps/1/ny.jpg',
    //         'textures/environmentMaps/1/pz.jpg',
    //         'textures/environmentMaps/1/nz.jpg'
    //     ]
    // },
    // {
    //     name: 'grassColorTexture',
    //     type: 'texture',
    //     path: 'textures/dirt/color.jpg'
    // },
    // {
    //     name: 'stanzab',
    //     type: 'gltfModel',
    //     path: 'models/cube.glb'
    // }
    // {
    //     name: 'foxModel',
    //     type: 'gltfModel',
    //     path: 'models/Fox/glTF/Fox.gltf'
    // }
    // {
    //     name: 'divano',
    //     type: 'gltfModel',
    //     path: 'models/dakota1.glb'
    //     // path: 'models/allen1.glb'
    //     // path: 'models/AUTOREVERSE5.glb'
    // },
]